export const VIDEOS = '/';
export const NEW_VIDEO = '/new';


// WEBPACK FOOTER //
// ./src/constants/routes.js